import PubSub from "underpub-js";
import slick from "slick-carousel";

var ListingInfoSlider = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-ListingInfoSlider',
  };

  $.extend(true, this.options, options);

};

ListingInfoSlider.prototype.init = function () {

  var self = this;

  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);
  self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  self.$items.slick({
    prevArrow: self.$arrowPrev,
	nextArrow: self.$arrowNext,
    slidesToShow: 4,
    infinite: true,
	autoplay: true,
	autoplaySpeed: 8000,
    responsive: [{
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
      },
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    }]
  });

};

export default ListingInfoSlider;